export const formatPayloadForLynTask = (payload, scriptName, processCode) => {
	if (typeof payload !== 'object' || payload === null) {
		throw new Error('The payload must be a non-null object.');
	}

	// 1. Convert the payload object to a JSON string.
	const jsonString = JSON.stringify(payload);

	// 2. Encode the JSON string into a Base64 string.
	// btoa() is a browser function. For Node.js environments, you would use Buffer.
	const base64Data = btoa(jsonString);

	// 3. Construct the final formatted object.
	const formattedPayload = {
		data: base64Data,       // The Base64 encoded data
		scriptName,             // ES6 shorthand for scriptName: scriptName
		processCode,            // ES6 shorthand for processCode: processCode
		payloadData: payload,   // The original, unencoded payload
	};

	return formattedPayload;
};